var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-body",
    class: {
      'modal-nudge': _vm.status
    }
  }, [_c('form', {
    staticClass: "auth",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('label', {
    staticClass: "inp-text inp-auth",
    class: {
      'inp-error': _vm.status
    },
    on: {
      "input": _vm.input
    }
  }, [_c('div', {
    staticClass: "inp-label"
  }, [_vm._v("Fill in your username:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "placeholder": ". . . . . . . . . ."
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-save",
    attrs: {
      "type": "submit",
      "disabled": !_vm.name
    }
  }, [_vm._v("start")]), _vm._v(" "), (_vm.status === 404) ? _c('div', {
    staticClass: "auth-feedback"
  }, [_vm._v("\n        Unknown user, do you want to "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add($event)
      }
    }
  }, [_vm._v("add it")]), _vm._v("?\n      ")]) : _c('div', {
    staticClass: "auth-feedback",
    domProps: {
      "textContent": _vm._s(_vm.status ? 'An error occurred' : '')
    }
  })])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7568b4c6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAuth.vue
// module id = 102
// module chunks = 1